<template>
  <BasePageContainer class="page member_edit">
    <div class="page__head member_edit-head fixed-top p-3">
      <h1 class="member_edit-head__heading">
        <router-link
          to="/admin/members/"
          class="member_edit-head__back">
          <span class="material-icons">
            arrow_back_ios
          </span>
        </router-link>
        ユーザー編集
      </h1>
    </div>
    <div class="member_edit__body general-form pt-8 pb-4">
      <form>
        <validation-observer v-slot="observer">
          <div class="general-form__group form-group row">
            <label class="col-4 col-form-label">名前</label>
            <div class="col-8">
              <validation-provider
                v-slot="v"
                name="名前"
                rules="required|max:50">
                <b-form-input
                  v-model="profile.name"
                  type="text"
                  hide-header />
                <p class="text-primary">
                  {{ v.errors[0] }}
                </p>
              </validation-provider>
            </div>
          </div>
          <div class="general-form__group form-group row">
            <label
              for="email"
              class="col-4 col-form-label">メールアドレス</label>
            <div class="col-8">
              <b-form-input
                v-model="profile.email"
                type="text"
                hide-header />
            </div>
          </div>
          <template v-if="studentNumberOption">
            <div class="general-form__group form-group row">
              <label class="col-4 col-form-label">学年</label>
              <div class="col-8">
                <b-form-select
                  v-model="grade"
                  :options="gradeOptions" />
              </div>
            </div>
            <div class="general-form__group form-group row">
              <label class="col-4 col-form-label">組</label>
              <div class="col-8">
                <b-form-select
                  v-model="homeroom"
                  :options="homeroomOptions" />
              </div>
            </div>
            <div class="general-form__group form-group row">
              <label class="col-4 col-form-label">出席番号</label>
              <div class="col-8">
                <b-form-select
                  v-model="attendanceNumber"
                  :options="attendanceNumberOptions" />
              </div>
            </div>
          </template>
          <div class="general-form__group form-group row">
            <label
              class="col-4 col-form-label">並び順</label>
            <div class="col-8">
              <validation-provider
                v-slot="v"
                name="並び順"
                rules="required">
                <b-form-input
                  v-model="profile.sortNo"
                  type="number"
                  hide-header />
                <p class="text-primary">
                  {{ v.errors[0] }}
                </p>
              </validation-provider>
            </div>
          </div>
          <div class="general-form__group form-group row">
            <label
              for="title"
              class="col-4 col-form-label">役職</label>
            <div class="col-8">
              <b-form-input
                v-model="profile.position"
                type="text"
                data-testid="position-input"
                hide-header />
            </div>
          </div>
          <div class="general-form__group form-group row">
            <label
              for="team"
              class="col-4 col-form-label">グループ</label>
            <div class="col-8">
              <b-form-select
                v-model="department"
                :options="selectDepartments" />
            </div>
          </div>
          <div class="general-form__group form-group row">
            <label
              for="team"
              class="col-4 col-form-label">閲覧可能なグループ</label>
            <div class="col-8">
              <b-form-checkbox-group
                v-model="accessibleDepartments"
                :options="selectDepartments"
                name="flavour-1a"
                stacked />
            </div>
          </div>
          <div class="general-form__group form-group row">
            <label
              class="col-4 col-form-label">権限</label>
            <div class="col-8">
              <label>{{ roleName }}</label>
            </div>
          </div>
          <div
            class="general-form__group form-group row align-items-center">
            <label
              for="photo"
              class="col-4 col-form-label">画像登録</label>
            <div
              v-if="avatarImageUrl === null"
              class="col-8 mt-2">
              <img
                src="@/assets/images/unknown.png"
                class="img-fluid rounded-circle general-form__img">
              <div class="general-form__btn-group d-flex mt-2">
                <label
                  for="photo"
                  class="btn btn-secondary btn--small mr-2">
                  <b-form-file
                    placeholder="画像を選択"
                    browse-text="選択"
                    accept="image/*"
                    @input="onInputImage" />
                </label>
              </div>
            </div>
            <div
              v-else
              class="col-8 mt-2">
              <img
                :src="avatarImageUrl"
                class="img-fluid rounded-circle general-form__img">
              <div class="general-form__btn-group d-flex mt-2">
                <p
                  class="h2"
                  style="position: absolute; top: 0px; left: 100px;"
                  @click="onClickImageDelete">
                  <b-icon-x-circle-fill />
                </p>
                <label
                  for="photo"
                  class="btn btn-secondary btn--small mr-2">
                  <b-form-file
                    placeholder="画像を選択"
                    browse-text="選択"
                    accept="image/*"
                    @input="onInputImage" />
                </label>
              </div>
            </div>
          </div>
          <div class="general-form__group form-group row">
            <label
              for="memo"
              class="col-4 col-form-label">
              メモ
            </label>
            <div class="col-8">
              <b-form-textarea
                id="textarea"
                v-model="profile.memo"
                placeholder="メモ"
                rows="5"
                disabled=""
                max-rows="10" />
            </div>
          </div>
          <div class="general-form__btn row mt-5">
            <div class="col-6">
              <button
                type="button"
                class="btn btn-block btn-cancel"
                @click="onClickCancel">
                キャンセル
              </button>
            </div>
            <div class="col-6">
              <button
                type="button"
                class="btn btn-block btn-primary"
                @click="observer.passes(onClickSave)">
                保存
              </button>
            </div>
          </div>
        </validation-observer>
      </form>
      <div
        class="row mt-5">
        <div class="col-4" />
        <div class="col-8 mt-2">
          <button
            v-if="profile.isActive"
            type="button"
            class="btn btn-block btn-secondary"
            @click="onClickUnsubscribe">
            ユーザーの利用停止
          </button>
          <button
            v-else
            type="button"
            class="btn btn-block btn-secondary"
            @click="onClickRivive">
            ユーザーの利用再開
          </button>
        </div>
      </div>
    </div>
  </BasePageContainer>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import loadImage from 'blueimp-load-image'
import { getRoleName } from '@/helper/role'
import { gradeOptions, homeroomOptions, attendanceNumberOptions } from '@/helper/studentNumber'
export default {
  beforeRouteLeave(to, from, next) {
    if (to.path === '/admin/members/') {
      this.$store.commit('departments/setReturnMember', {
        memberId: this.$route.params.id,
        departmentId: this.profile.department?.id,
      })
    }
    next()
  },
  data() {
    return {
      profile: {},
      // avatarのFile
      avatarFile: null,
      // avatarのURLまたはbase64文字列
      avatarImageUrl: null,
      department: null,
      departments: [],
      accessibleDepartments: [],
      grade: null,
      homeroom: null,
      attendanceNumber: null,
      gradeOptions,
      homeroomOptions,
      attendanceNumberOptions,
    }
  },
  computed: {
    ...mapState('auth', ['user']),
    ...mapGetters('tenant', ['studentNumberOption']),
    selectDepartments (){
      return this.departments.map(v=> {return {value: v.id, text: v.name}})
    },
    roleName(){
      return getRoleName(this.profile.role)
    }
  },
  async mounted() {
    this.$store.commit('startLoading')
    const [tenantInfo, user, departments] = await Promise.all([
      this.$axios.get('/tenants/').then(res => res.data).catch(() => null),
      this.$axios.get(`/accounts/manage_staff/${this.$route.params.id}/`).catch(() => {
        this.$store.commit('notify/set', {isUnknownError: true, type: 'danger'})
      }),
      this.$axios.get('/departments/?ordering=-sort_no').catch(() => {
        this.$store.commit('notify/set', {isUnknownError: true, type: 'danger'})
      })
    ])
    if (tenantInfo) {
      this.$store.commit('tenant/setTenantInfo', tenantInfo)
    }
    this.profile = user.data
    if (user.data.avatar) {
      this.avatarImageUrl = user.data.avatar
    }
    if (user.data.department){
      this.department = user.data.department.id
    }
    if (user.data.accessibleDepartments){
      this.accessibleDepartments = user.data.accessibleDepartments.map(v=> v.id)
    }
    this.grade = user.data.grade ?? null
    this.homeroom = user.data.homeroom ?? null
    this.attendanceNumber = user.data.attendanceNumber ?? null
    this.departments = departments.data.results

    this.$store.commit('finishLoading')
  },
  methods: {
    // 利用停止
    async onClickUnsubscribe(){
      if (this.user.id === this.profile.id){
        alert('自分自身を利用停止にはできません')
        return 
      }
      if (!window.confirm(`ユーザー「${this.profile.name}」を利用停止します。よろしいですか？`)) return

      this.$store.commit('startLoading')
      await this.$axios.post('/accounts/unsubscribe/', {user_id: this.profile.id})
        .catch(() => {
          this.$store.commit('notify/set', {isUnknownError: true, type: 'danger'})
        })
      this.$router.push('/admin/members/')
      this.$store.commit('finishLoading')

    },
    // 利用再開
    async onClickRivive(){
      this.$store.commit('startLoading')
      await this.$axios.post('/accounts/revive/', {user_id: this.profile.id})
        .catch(() => {
          this.$store.commit('notify/set', {isUnknownError: true, type: 'danger'})
        })
      this.$router.push('/admin/members/')
      this.$store.commit('finishLoading')
    },
    onClickSave(){
      this.$store.commit('startLoading')
      const params = {
        name: this.profile.name,
        sortNo: this.profile.sortNo,
        position: this.profile.position,
        homeView: this.profile.homeView,
        enabledSendEmail: this.profile.enabledSendEmail,
        email: this.profile.email,
        department: this.department,
        accessibleDepartments: this.accessibleDepartments

      }
      if (this.studentNumberOption) {
        params.grade = this.grade
        params.homeroom = this.homeroom
        params.attendanceNumber = this.attendanceNumber
      }
      // 顔写真は変化がないのであれば変更しない
      if (this.avatarImageUrl !== this.profile.avatar) {
        params.avatar = this.avatarImageUrl
      }

      this.$axios.patch(`/accounts/manage_staff/${this.$route.params.id}/`, params).then(() => {
        this.$store.commit('notify/set', {message: '保存しました。'})
        this.profile = { ...this.profile, department: { id: this.department } }
      }).catch((e) => {
        console.error(e)
        this.$store.commit('notify/set', {isUnknownError: true, type: 'danger'})
      }).finally(() => {
        this.$store.commit('finishLoading')
        this.$router.push('/admin/members/')
      })

    },
    onClickCancel(){
      this.$router.push('/admin/members/')
    },
    onClickImageDelete() {
      this.avatarFile = null
      this.avatarImageUrl = null
    },
    toBase64(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader()
        reader.readAsDataURL(file)
        reader.onload = () => resolve(reader.result)
        reader.onerror = error => reject(error)
      })
    },
    onInputImage(file) {
      if (!file) return

      loadImage.parseMetaData(file, data => {
        const options = {
          maxWidth: 256,
          maxHeight: 256,
          canvas: true // canvas にリサイズ後の写真を書出す為必要
        }
        if (data.exif) {
          options.orientation = data.exif.get('Orientation')

        }
        loadImage(
          file,
          canvas => {
            this.avatarImageUrl = canvas.toDataURL('image/png')
          },
          options
        )
      })
    },
  }

}
</script>

<style lang="scss" scoped>
.member_edit-head{
  background-color: $l-blue;
  @media screen and (min-width:992px) {
    right: 0;
    left: 120px;
  }
  &__back{
    height: 22px;
    width: auto;
    color: $white;
    display: inline-block;
    vertical-align: text-bottom;
  }
  &__heading{
    color: $white;
    font-size: $fs-lg;
    font-weight: bold;
  }
}
.member_edit{
  &__head{
    background-color: $primary;
    color: $white;
    border-radius: 8px;
  }
  &__img{
    object-fit: cover; 
    width: 60px;
    height: 60px;
    max-width: 60px;
    
  }
  &__name{
    font-weight: bold;
  }
  &__title{
    font-size: $fs-s;
    line-height: 150%;
    font-weight: bold;
  }
  &__team{
    font-size: $fs-s;
    line-height: 150%;
    font-weight: bold;
  }
}

.form-info{
  color: $grey09;
  &__logout{
    text-decoration: none;
    font-weight: bold;
    color: $grey09;
    font-size: $fs-m;
  }
  &__date{
    font-size: $fs-m;
  }
}
</style>